

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { ADVERTISEMENT_DEFAULT, CLI_CINEMA_CLIENT_ID, FEATURES, PROGRAM_CINEMAS, WPSERVER } from '../../../constants/state'
import { advertisementsAddItem } from '../../../actions'
import EditAdvertisements from '../../PageEditItem/present/EditAdvertisements'
import sortCinemas from '../../../functions/sortCinemas'
import { ADVERTISEMENT_FIREPLACE, ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_INTERSCROLLER, ADVERTISEMENT_MAIN_SLIDER, ADVERTISEMENT_OVERVIEW_BANNER, ADVERTISEMENT_OVERVIEW_HERO } from '../../../constants/advertisementTypes'
import selectionTypes from '../../../constants/itemSelectionsDisplayTypes'
import configAdvertisements from '../../../config-advertisements'


const mapStateToProps = state => ({
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    features: getData(state, FEATURES),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    sliderAppearance: state.getIn([WPSERVER, 'data', 'data', 'front', 'slider_appearance']),
    bannerAppearance: state.getIn(['wpServerData', 'data', 'data', 'advertisement_config', 'program_overview_tiles_style'])
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(advertisementsAddItem(itemData, ownProps.closePagePath))
    }
})


class AddAdvertisementsContainer extends Component {
    constructor(props) {
        super(props)
    }

    getAdvertisementType()  {
        const { params } = this.props
        let type

        if(
            !params.hasOwnProperty('advertisementType') && 
            params.hasOwnProperty('selectionType') && 
            selectionTypes.MAIN === params.selectionType
        )  {
            type = ADVERTISEMENT_MAIN_SLIDER
        } else if (
            params.hasOwnProperty('advertisementType') ||
            ADVERTISEMENT_OVERVIEW_BANNER === params.advertisementType || 
            ADVERTISEMENT_OVERVIEW_HERO === params.advertisementType || 
            ADVERTISEMENT_INTERSCROLLER === params.advertisementType ||
            ADVERTISEMENT_MAIN_SLIDER === params.advertisementType ||
            ADVERTISEMENT_FIREPLACE === params.advertisementType
        ) {
            type  = params.advertisementType
        } else if(
            !params.hasOwnProperty('advertisementType') && 
            params.hasOwnProperty('selectionType') && 
            selectionTypes.ADVERTISEMENT === params.selectionType
        )  {
            type = ADVERTISEMENT_HOME_BANNER
        } else{
            type = false
        }
    
        return type
    }

    getImagesDefault(type) {
        let images = false

        if(configAdvertisements.images.hasOwnProperty(type)) {
            if(false === images)  {
                images = {}
            }

            Object.keys(configAdvertisements.images[type]).map(key => {
                images[key]  = null
            })
        }
    
        // if(
        //     ADVERTISEMENT_MAIN_SLIDER === type ||
        //     ADVERTISEMENT_OVERVIEW_BANNER === type
        // ) {
        //     images = {
        //         desktop: null,
        //         mobile: null
        //     }
        // } else if(ADVERTISEMENT_OVERVIEW_HERO === type ) {
        //     images = {
        //         desktopOne: null,
        //         desktopTwo: null,
        //         desktopThree: null,
        //         mobile: null
        //     }
        // } else if(ADVERTISEMENT_INTERSCROLLER === type)  {
        //     images = {
        //         mobile: null
        //     }
        // } else {
        //     images = null
        // }
    
        return images
    }

    getDefaultData(type) {
        const { clientCinemaId, cliCinemas } = this.props

        return type ? {
            ...ADVERTISEMENT_DEFAULT,
            cinemasFilter: sortCinemas(clientCinemaId, cliCinemas),
            type: type,
            images: this.getImagesDefault(type)
        } : false
    }

    render() {
        const { cliCinemas, clientCinemaId, features, sliderAppearance, closePagePath, onUpdateItem, bannerAppearance } = this.props 
        const type = this.getAdvertisementType()
        const defaultData = this.getDefaultData(type)

        return <EditAdvertisements
            itemData={defaultData}
            cliCinemas={cliCinemas}
            clientCinemaId={clientCinemaId}
            features={features}
            sliderAppearance={sliderAppearance}
            bannerAppearance={bannerAppearance}
            closePagePath={closePagePath}
            onUpdateItem={onUpdateItem}
        />
    }
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(AddAdvertisementsContainer)

